var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/radio-button/RadioButton.tsx
import { forwardRef } from "react";
import { cva } from "class-variance-authority";

// src/radio-button/RadioButtonCheck.tsx
import { jsx } from "react/jsx-runtime";
function RadioButtonCheck() {
  return /* @__PURE__ */ jsx("div", { className: "rb-svg", children: /* @__PURE__ */ jsx(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("polyline", { points: "20 6 9 17 4 12" })
    }
  ) });
}
RadioButtonCheck.displayName = "RadioButtonCheck";
var RadioButtonCheck_default = RadioButtonCheck;

// src/radio-button/RadioButton.tsx
import "@bice_vida/ds-styles-radio-button";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var radioButtonStyles = cva("rb", {
  variants: {
    size: {
      s: "rb-s",
      m: "rb-m",
      l: "rb-l"
    }
  },
  defaultVariants: {
    size: "m"
  }
});
var RadioButton = forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { name, children, disabled, size, checked, value, onChange, className } = _b, props = __objRest(_b, ["name", "children", "disabled", "size", "checked", "value", "onChange", "className"]);
    return /* @__PURE__ */ jsxs("label", { className: radioButtonStyles({ size, className }), children: [
      /* @__PURE__ */ jsx2(
        "input",
        __spreadValues({
          checked,
          className: "rb-input",
          disabled,
          name,
          onChange,
          ref: forwardedRef,
          type: "radio",
          value
        }, props)
      ),
      /* @__PURE__ */ jsxs("div", { className: "rb-content-item", children: [
        /* @__PURE__ */ jsx2("div", { className: "rb-content-check", children: /* @__PURE__ */ jsx2("div", { className: "rb-check", children: /* @__PURE__ */ jsx2(RadioButtonCheck_default, {}) }) }),
        children
      ] })
    ] });
  }
);
RadioButton.displayName = "RadioButton";
var RadioButton_default = RadioButton;
export {
  RadioButton_default as RadioButton
};
